import { Button } from "../../../../core/components/atoms/Button";
import { Icon } from "../../../../core/components/atoms/Icon";
import { useNewSubjectStore } from "../../stores/newSubjectStore";
import { usePrintComponentStore } from "../../../../core/components/organism/PrintComponent/store/usePrintComponentStore";
import { useDisciplinesAuxStore } from "../../stores/auxStore";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import MultipleSelect from "../../../../core/components/atoms/MultipleSelect";
import FilterTagsList from "../FilterTagsList";
import './style.css';

interface ISubjectSelectSection {
  type: string;
}

const SubjectSelectSection: React.FC<ISubjectSelectSection> = ({ type }) => {
  const location = useLocation();

  const { setSelectedSubjects, selectedSubjects, selectOptions } = useNewSubjectStore()
  const { setHasApiCall } = usePrintComponentStore();
  const { setOpenModal } = useDisciplinesAuxStore();

  const SelectButtons = () => {
    if(type !== 'exercicio') {
      return (
        <Button variant='text' className='p-0' onClick={() => setOpenModal('normal-filter')}>
          <Icon
            Icon='filter_list'
            type='material'
            className='xs:text-sm md:text-md'
          />
          <span className='xs:text-sm md:text-md '>
            Filtrar { type === 'videoaula' ? 'videoaulas' : type === 'podcast' ? 'podcasts' : 'materiais' }
          </span>
        </Button>
      )
    }

    return (
      <div className='flex flex-row items-center gap-md w-fit'>
        <Button
          variant='text'
          onClick={() => { 
            setHasApiCall(true);
            setOpenModal('exercise-print');
          }}
          className='p-0'
        >
          <Icon
            Icon='print'
            type='material'
            className='xs:text-sm md:text-md'
          />
          <span className='text-sm xs:block md:hidden'>Imprimir</span>
          <span className='text-md xs:hidden md:block'>
            Imprimir lista de exercícios
          </span>
        </Button>
        <Button
          variant='text'
          onClick={() => {
            setOpenModal('exercise-filter');
          }}
          className='p-0'
        >
          <Icon
            Icon='filter_list'
            type='material'
            className='xs:text-sm md:text-md'
          />
          <span className='text-sm xs:block md:hidden'>Filtrar</span>
          <span className='text-md xs:hidden md:block'>
            Filtrar exercícios
          </span>
        </Button>
      </div>
    )
  }

  useEffect(() => {
    // Recuperar subjects salvos do localStorage ao carregar
    const savedSubjects = localStorage.getItem('selectedSubjects');
    if (savedSubjects) {
      const subjects = JSON.parse(savedSubjects);
      const validSubjects = selectOptions.filter(option => subjects.includes(option.value));

      setSelectedSubjects(validSubjects.map(it => it.value));
    }

    if (location.search) {
      const queryParams = new URLSearchParams(location.search);
      const subject = queryParams.get('subject');

      if (subject) {
        setSelectedSubjects([subject]);
        localStorage.setItem('selectedSubjects', JSON.stringify([subject]));
      }
    }
  }, [location, selectOptions]);

  // Salvar subjects no localStorage quando mudarem
  useEffect(() => {
    localStorage.setItem('selectedSubjects', JSON.stringify(selectedSubjects));
  }, [selectedSubjects]);

  return (
    <div className='flex flex-col gap-lg'>
      <div className="flex flex-row gap-lg items-center">
        <MultipleSelect
          label='Selecione os assuntos'
          options={selectOptions}
          selected={selectedSubjects}
          onChange={(value) => setSelectedSubjects(value)}
          className='flex-1'
        />
        {SelectButtons()}
      </div>  
      <FilterTagsList origin="main"/>
    </div>
  )
}

export default SubjectSelectSection;